import apiKindsSport from '@/api/kinds-sport'

const state = {
  isSubmitting: false,

  kindsSport: [],
  isLoading: false,
  validationErrors: null,

  kindsSportType: [],
  isLoadingType: false,
  validationErrorsType: null
}

export const mutationTypes = {
  getKindsSportStart: '[kindsSport] getKindsSportStart',
  getKindsSportSuccess: '[kindsSport] getKindsSportSuccess',
  getKindsSportFailure: '[kindsSport] getKindsSportFailure',

  addKindsSportStart: '[kindsSport] addKindsSportStart',
  addKindsSportSuccess: '[kindsSport] addKindsSportSuccess',
  addKindsSportFailure: '[kindsSport] addKindsSportFailure',

  deleteKindsSportStart: '[kindsSport] deleteKindsSportStart',
  deleteKindsSportSuccess: '[kindsSport] deleteKindsSportSuccess',
  deleteKindsSportFailure: '[kindsSport] deleteKindsSportFailure',

  getKindsSportTypeStart: '[kindsSport] getKindsSportTypeStart',
  getKindsSportTypeSuccess: '[kindsSport] getKindsSportTypeSuccess',
  getKindsSportTypeFailure: '[kindsSport] getKindsSportTypeFailure'
}

export const actionType = {
  getKindsSport: '[kindsSport] getKindsSport',
  addKindsSport: '[kindsSport] addKindsSport',
  deleteKindsSport: '[kindsSport] deleteKindsSport',
  getKindsSportType: '[kindsSport] getKindsSportType'
}

const mutations = {
  [mutationTypes.getKindsSportStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getKindsSportSuccess](state, payload) {
    state.isLoading = false
    state.kindsSport = payload
  },

  [mutationTypes.getKindsSportFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.addKindsSportStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.addKindsSportSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.addKindsSportFailure](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteKindsSportStart]() {},

  [mutationTypes.deleteKindsSportSuccess]() {},

  [mutationTypes.deleteKindsSportFailure]() {},

  [mutationTypes.getKindsSportTypeStart](state) {
    state.isLoadingType = true
    state.validationErrorsType = null
  },

  [mutationTypes.getKindsSportTypeSuccess](state, payload) {
    state.isLoadingType = false
    state.kindsSportType = payload
  },

  [mutationTypes.getKindsSportTypeFailure](state, payload) {
    state.isLoadingType = false
    state.validationErrorsType = payload
  }
}

const actions = {
  [actionType.getKindsSport](context) {
    context.commit(mutationTypes.getKindsSportStart)
    return new Promise(resolve => {
      apiKindsSport
        .getKindsSport()
        .then(response => {
          context.commit(mutationTypes.getKindsSportSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.getKindsSportFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.addKindsSport](context, sport) {
    context.commit(mutationTypes.addKindsSportStart)
    return new Promise(resolve => {
      apiKindsSport
        .addKindsSport(sport)
        .then(response => {
          context.commit(mutationTypes.addKindsSportSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.addKindsSportFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.deleteKindsSport](context, {id}) {
    context.commit(mutationTypes.deleteKindsSportStart)
    return new Promise(resolve => {
      apiKindsSport
        .deleteKindsSport(id)
        .then(response => {
          context.commit(mutationTypes.deleteKindsSportSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.deleteKindsSportFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.getKindsSportType](context) {
    context.commit(mutationTypes.getKindsSportTypeStart)
    return new Promise(resolve => {
      apiKindsSport
        .getKindsSportType()
        .then(response => {
          context.commit(mutationTypes.getKindsSportTypeSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.getKindsSportTypeFailure,
            result.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
